import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { FaturaService } from './../../../../services/fatura.service';
import { IFaturaLista } from '../../../../interfaces/ifatura-lista';
import { IAgendaEduAccessInfo } from '../../../../interfaces/iagenda-edu-access-info';
import { IResponsible } from './../../../../interfaces/iresponsible';
import { ResponsibleService } from './../../../../services/responsible.service';
import { AccessInfo } from './../../../../utils/access-info';
import { Fatura } from './../../../../utils/fatura';

@Component({
  selector: 'app-fatura-listar',
  templateUrl: './fatura-listar.component.html',
  styleUrls: ['./fatura-listar.component.scss'],
})
export class FaturaListarComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private faturaService: FaturaService,
    private responsibleService: ResponsibleService,
    private router: Router
  ) {}

  private responsibleDataLoaded: boolean = false;
  private responsibleData!: IResponsible | null;
  listaFaturas: IFaturaLista[] = [];

  async ngOnInit() {
    this.setAndCheckAccessFaturaInfo(this.activatedRoute.snapshot);

    const accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();

    const urlOrigem = `/responsavel/${accessInfo.responsibleToken}/aluno/${accessInfo.studentToken}/${accessInfo.accessToken}/fichafinanceira`;

    await this.getResponsibleData(accessInfo, urlOrigem);
  }

  public async getResponsibleData(
    accessInfo: IAgendaEduAccessInfo,
    urlOrigem: string
  ) {
    let responsibleData: IResponsible | null =
      await this.responsibleService.getResponsibleData(accessInfo, urlOrigem);

    if (!responsibleData || !responsibleData.isFinancialResponsible) {
      this.treatForbiddenResponsible(urlOrigem);
    } else {
      this.responsibleDataLoaded = true;
      this.responsibleService.setResponsibleDataStored(responsibleData);
      this.responsibleService.logAcesso(
        urlOrigem,
        'Acesso a tela de faturas permitido'
      );
    }

    this.responsibleData = responsibleData;

    AccessInfo.setStudentID(
      responsibleData ? responsibleData.studentId.toString() : ''
    );
    
    AccessInfo.setMainStudentServiceId(
      responsibleData && responsibleData.mainStudentServiceId ? responsibleData.mainStudentServiceId.toString() : ''
    );

    
  }

  isResponsibleDataLoaded() {
    return this.responsibleDataLoaded;
  }

  getResponsibleDataLoaded() {
    return this.responsibleData;
  }

  treatForbiddenResponsible(urlOrigem: string) {
    this.responsibleService.logAcesso(
      urlOrigem,
      'Acesso a tela de faturas não permitido a RP'
    );
    this.router.navigate(['fichafinanceira/sempermissao']);
    return [];
  }

  private setAndCheckAccessFaturaInfo(route: ActivatedRouteSnapshot) {
    let accessToken: string = route.params['accesstoken'],
      responsible: string = route.params['responsible'],
      student: string = route.params['student'];
    let accessInfo: IAgendaEduAccessInfo = AccessInfo.getAccessInfo();
    if (
      accessToken == accessInfo.accessToken &&
      responsible == accessInfo.responsibleToken &&
      student == accessInfo.studentToken
    ) {
      this.listaFaturas = Fatura.treatFaturasAsFaturasLista(
        this.faturaService.getFaturasStored()
      );
    } else {
      AccessInfo.setAccessInfo(accessToken, student, responsible);
    }
  }
}
